var Spinner = require("components/utility/Spinner");
var Masonry = require("react-masonry-component");

// Use the original board's CSS
require("utility/board.scss");

class AltBoard extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		if (this.props.loading) {
			var spinner = (<Spinner scale={ 1.7 } />);
		}

		var masonryOptions = { gutter: 15 }

		var className = "tileGridWrapper";
		if (this.props.narrowBoard) {
			className += " narrowGrid";
		}

		return (
			<div className={ className } ref="wrapper">
				<Masonry updateOnEachImageLoad={ true } options={ masonryOptions } ref="masonry" >
				    { this.props.children }
			  	</Masonry>
			  	{ spinner }
			</div>
		);
	}

	checkScroll() {
		if (!this.props.loading && this.props.onScrollToBottom) {
			var $wrapper = $(this.refs.wrapper);
			var threshold = 300;
			var lim = $wrapper.offset().top + $wrapper.height();
			var loc = $(window).scrollTop() + $(window).height();
			if (loc + threshold > lim) {
				this.props.onScrollToBottom();
			}			
		}
	}

	refreshMasonry() {
		this.refs.masonry.forceUpdate();
	}

	componentDidMount() {
		$(window).scroll(this.checkScroll);
		$(window).on("masonry-update", this.refreshMasonry);
	}

	componentWillUnmount() {
		$(window).off("scroll", this.checkScroll);
		$(window).off("masonry-update", this.refreshMasonry);
	}
};

AltBoard.propTypes = StrictPropTypes({
	children: PropTypes.array.isRequired,

	// Show a spinner and block onEnd notices if this is true
	loading: PropTypes.bool,

	// Function to call once the user has scrolled to the bottom
	onScrollToBottom: PropTypes.func,

	// Makes the board narrower (3 columns), to allow for a page sidebar
	narrowBoard: PropTypes.bool,
});

module.exports = AltBoard;



// WEBPACK FOOTER //
// ./modules/components/utility/AltBoard.js